/**
 * Rutas que exigen una sesión activa.
 *
 * Única fuente de verdad. La consumen el interceptor de 401 de `apiClient`, para
 * decidir si un 401 merece expulsar al usuario a `/login`, y cualquier guard de
 * ruta que necesite el mismo criterio.
 *
 * Ver docs/design.md 16.8.1.
 */

/**
 * Prefijos de ruta bajo los que vive el shell autenticado, más la única pantalla
 * de acceso que sí exige sesión.
 *
 * `/app` es todo el panel. `/change-password` está aquí porque `RequireSession`
 * la protege: sin sesión no hay credencial que cambiar.
 */
export const PROTECTED_PATH_PREFIXES = ['/app', '/change-password'] as const;

/**
 * ¿La ruta actual pertenece al área autenticada?
 *
 * La comparación es por **segmento**, no un `startsWith` ingenuo: `/app` y
 * `/app/users` cuentan, `/applicable` no. Sin esa precaución, cualquier ruta
 * futura que empiece por los mismos caracteres heredaría el redirect.
 */
export function isProtectedPath(pathname: string): boolean {
  return PROTECTED_PATH_PREFIXES.some((prefix) => {
    if (pathname === prefix) return true;
    // El prefijo debe cerrar en un borde de segmento: `/app` + `/…`.
    return pathname.startsWith(`${prefix}/`);
  });
}
